import styled from "styled-components"
import {
  border,
  space,
  color,
  typography,
  layout,
  position,
  shadow,
} from "styled-system"

import {
  getFontWeightFromProps,
  getFontStyleFromProps,
} from "../services/fonts.js"

const Text = styled.div.attrs(props => ({
  blacklist: ["centered"],
  display: "inline",
  fontWeight: props.fontWeight ?? getFontWeightFromProps(props),
  fontStyle: props.fontStyle ?? getFontStyleFromProps(props),
}))`
  ${border}
  ${space}
  ${color}
  ${typography}
  ${layout}
  ${position}
  ${shadow}

  white-space: ${props => (props.nowrap ? "nowrap" : "normal")};
  overflow-wrap: break-word;

  ${props => (props.uppercase ? "text-transform: uppercase;" : null)};
  ${props => (props.notSelectable ? "user-select: none;" : null)};
  ${props => (props.underlined ? "text-decoration: underline" : null)};
  ${props =>
    props.ellipsis
      ? `
          display: block;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;`
      : null};
  ${props => (props.clickable ? "cursor: pointer;" : null)};
`

Text.displayName = "Text"

export default Text
